import { render, staticRenderFns } from "./PDPReviewsPaginated.vue?vue&type=template&id=607d5b4b&scoped=true"
import script from "./PDPReviewsPaginated.vue?vue&type=script&lang=js"
export * from "./PDPReviewsPaginated.vue?vue&type=script&lang=js"
import style0 from "./PDPReviewsPaginated.vue?vue&type=style&index=0&id=607d5b4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607d5b4b",
  null
  
)

export default component.exports